import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import * as Yup from 'yup';
import { Form, FormActions, FormInput, FormTextArea } from '../../../../components/form/index.js';
import { useMeasurementUnitContext } from '../../../../contexts/measurementUnits/measurementUnit.tsx';
import { MeasurementUnit } from '../../../../models/measurementUnits/measurementUnit.ts';

const validationSchema = Yup.object().shape({
    name: Yup
        .string()
        .required('Name is required')
        .min(2, "Name is too short")
        .max(255, 'Name is too long'),
    description: Yup.string().nullable(),
});

const MeasurementUnitBody = () => {
    const { id } = useParams(); // Get the 'id' from the route parameter
    const {
        isLoaded,
        measurementUnit,
        insertMeasurementUnit,
        updateMeasurementUnit } = useMeasurementUnitContext();
    const [localMeasurementUnit, setLocalMeasurementUnit] = useState<MeasurementUnit>(measurementUnit);
    useEffect(() => {
        setLocalMeasurementUnit(measurementUnit);
    }, [measurementUnit])
    const [errors, setErrors] = useState<Record<string, string>>({});

    const handleInputChange = (e: any) => {
        const { id, value } = e.target;

        setLocalMeasurementUnit((prevData: MeasurementUnit) => ({
            ...prevData,
            [id]: value, // Update the corresponding field in state
        }));

        validationSchema
            .validateAt(id, { ...localMeasurementUnit, [id]: value })
            .then(() => setErrors((prev) => ({ ...prev, [id]: '' })))
            .catch((err) => setErrors((prev) => ({ ...prev, [id]: err.message })));
    };

    const handleSubmit = () => {
        validationSchema
            .validate(localMeasurementUnit, { abortEarly: false })
            .then(() => {
                setLocalMeasurementUnit(localMeasurementUnit);
                if (id === "create")
                    insertMeasurementUnit(localMeasurementUnit);
                else
                    updateMeasurementUnit(localMeasurementUnit);
            })
            .catch((err) => {
                const validationErrors: Record<string, string> = {};
                err.inner.forEach((error: Yup.ValidationError) => {
                    if (error.path) validationErrors[error.path] = error.message;
                });
                setErrors(validationErrors);
            });
    };

    if (!isLoaded) return;
    return (
        <Form>
            <FormInput
                entity={localMeasurementUnit}
                handleInputChange={handleInputChange}
                fieldName='name'
                label='Name'
                errors={errors} />
            <FormTextArea
                entity={localMeasurementUnit}
                handleInputChange={handleInputChange}
                fieldName='description'
                label='Description'
                errors={errors} />
            <FormActions
                mainAction={handleSubmit}
                mainActionText="Save"
                showCancelButton
            />
        </Form>
    );
};

export default MeasurementUnitBody;